import { WarningTwoTone } from "@ant-design/icons";
import { ContactSupport } from "@p0security/frontend-core/react";
import { Alert, Flex } from "@p0security/ui";
import { useFlags } from "launchdarkly-react-client-sdk";
import React, { useContext, useMemo } from "react";

import { IntegrationsContext } from "./IntegrationsContext.tsx";
import IntegrationTable from "./components/IntegrationTable";
import {
  approvers,
  directories,
  notifiers,
  resourceIntegrations,
  siems,
  trackers,
} from "./constants";

import "./styles.less";

export const IntegrationsList: React.FC<object> = () => {
  const flags = useFlags();

  const installations = useContext(IntegrationsContext);
  const numberOfResourcesSupported = flags.cloudResourcesSupported;

  const flaggedTrackers = useMemo(() => trackers(flags), [flags]);
  const flaggedResources = useMemo(() => resourceIntegrations(flags), [flags]);
  const flaggedDirectories = useMemo(() => directories(flags), [flags]);

  return (
    <>
      {numberOfResourcesSupported === 1 && (
        <Alert
          message={
            <>
              Your current plan only allows for the support of a single
              resource. To upgrade and enable support for multiple resources,
              please
              <ContactSupport />.
            </>
          }
          type="warning"
          icon={<WarningTwoTone twoToneColor="#faad14" />}
          showIcon
        />
      )}
      <IntegrationTable
        title="Notifiers"
        data={notifiers}
        installations={installations}
        zeroNotes={
          <Flex align="center" className="additional-details" gap={4}>
            <WarningTwoTone />
            You must install a notifier to get real-time notifications.
          </Flex>
        }
      />
      <IntegrationTable
        title="Trackers"
        data={flaggedTrackers}
        installations={installations}
      />
      <IntegrationTable
        title="Security Information & Event Managers"
        data={siems}
        installations={installations}
      />
      <IntegrationTable
        title="Approvers"
        data={approvers}
        installations={installations}
      />
      <IntegrationTable
        title="Directories"
        data={flaggedDirectories}
        installations={installations}
      />
      <IntegrationTable
        title="Resources"
        data={flaggedResources}
        installations={installations}
        zeroNotes={
          <Flex align="center" className="additional-details" gap={4}>
            <WarningTwoTone />
            You must install at least one resource to use P0.
          </Flex>
        }
      />
    </>
  );
};
